import { configureStore } from "@reduxjs/toolkit";
import authReducer from "@store/slices/auth.slice";
import filterReducer from "@store/slices/filter.slice";
import useCasesReducer from "@store/slices/usecase.slice";
import scorecardReducer from "@store/slices/scorecard.slice";
import adoptersReducer from "@store/slices/adoptersInfo.slice";
import customizeWeightsReducer from "@store/slices/customizeWeights.slice";
import shareMailReducer from "@store/slices/shareMail.slice";
import multiScorecardReducer from "@store/slices/multiScorecard.slice";
import deleteScorecardReducer from "@store/slices/deleteScorecard.slice";
import updateScorecardNameReducer from "@store/slices/updateScorecardName.slice";
import saveToScorecardReducer from "@store/slices/saveToScorecard.slice";
import teamSharingReducer from "@store/slices/teamSharing.slice";
import validMailReducer from "@store/slices/validMail.slice";
import scorecardFiltersReducer from "@store/slices/scorecardFilters.slice";
import popperScorecardsReducer from "@store/slices/popperScorecards.slice";
import relatedUseCasesReducer from "@store/slices/relatedUseCases.slice";
import caseExamplesDetailsReducer from "@store/slices/caseExamplesDetails.slice";
import caseExamplesReducer from "@store/slices/caseExamples.slice";
import caseExamplesSaveReducer from "@store/slices/caseExamplesSave.slice";
import caseExamplesSrchSuggReducer from "@store/slices/caseExamplesSrchSugg.slice";
import homeBannerReducer from "@store/slices/homebanner.slice";
import featuredUseCasesReducer from "@store/slices/featuredUseCases.slice";
import featuredCaseExamplesReducer from "@store/slices/featuredCaseExamples.slice";
import useCaseAssessmentsReducer from "@store/slices/useCaseAssessments.slice";
import gartnerAssessmentDetailsReducer from "@store/slices/gartnerAssessmentDetails.slice";
import relatedCaseExamplesReducer from "@store/slices/relatedCaseExamples.slice";
import createYourAssessmentReducer from "@store/slices/createYourAssessment.slice";
import downloadUseCasesReducer from "@store/slices/downloadUseCases.slice";
import uploadUseCasesReducer from "@store/slices/uploadUseCases.slice";
import customUseCasesReducer from "@store/slices/customUseCases.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filter: filterReducer,
    usecases: useCasesReducer,
    useCaseAdoptersInfo: adoptersReducer,
    scorecard: scorecardReducer,
    customizeWeights: customizeWeightsReducer,
    shareMail: shareMailReducer,
    multiScorecard: multiScorecardReducer,
    deleteScorecard: deleteScorecardReducer,
    updateScorecardName: updateScorecardNameReducer,
    saveToScorecard: saveToScorecardReducer,
    teamSharing: teamSharingReducer,
    validMail: validMailReducer,
    scorecardFilters: scorecardFiltersReducer,
    popperScorecards: popperScorecardsReducer,
    relatedUseCases: relatedUseCasesReducer,
    caseExamplesDetails: caseExamplesDetailsReducer,
    caseExamples: caseExamplesReducer,
    caseExamplesSave: caseExamplesSaveReducer,
    caseExamplesSrchSugg: caseExamplesSrchSuggReducer,
    homeBanner: homeBannerReducer,
    featuredUseCases: featuredUseCasesReducer,
    featuredCaseExamples: featuredCaseExamplesReducer,
    useCaseAssessments: useCaseAssessmentsReducer,
    gartnerAssessmentDetails: gartnerAssessmentDetailsReducer,
    relatedCaseExamples: relatedCaseExamplesReducer,
    createYourAssessment: createYourAssessmentReducer,
    downloadUseCases: downloadUseCasesReducer,
    uploadUseCases: uploadUseCasesReducer,
    customUseCases: customUseCasesReducer,
  },
});
